import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import MaterialIcon, {
  MtIcon,
} from "../../ui-elements/material-icon/material-icon";
import styles from "./energy-flow-node.module.scss";

interface IProps {
  x: number;
  y: number;
  title: string;
  value: string;
  value2?: string;
  icon: MtIcon;
  iconColor: string;
  iconBgColor: string;
  siteEnergySource?: React.ReactNode;
  otherInfo?: React.ReactNode;
  hideArrowIcon?: boolean;
}

const EnergyFlowNode = (props: IProps) => {
  const {
    x,
    y,
    title,
    icon,
    iconColor,
    iconBgColor,
    value,
    value2,
    siteEnergySource,
    otherInfo,
    hideArrowIcon,
  } = props;

  const [isMoreInfo, setIsMoreInfo] = useState(false);

  return (
    <div
      className={styles.energyFlowNodeContainer}
      style={{ left: x + "px", top: y + "px" }}
    >
      <Row className="align-items-center p-3 mx-0 pb-0">
        <Col
          className="col-auto p-2 rounded-3"
          style={{ backgroundColor: iconBgColor }}
        >
          <MaterialIcon
            icon={icon}
            color={iconColor}
            size={20}
            weight={500}
            className="justify-content-center"
          />
        </Col>
        <Col className="col-auto ms-2">
          <Row>
            <Col
              className={`${styles.letterSpacing} text-light font-weight-500 font-size-14`}
            >
              {title}
            </Col>
          </Row>
          <Row>
            <Col
              className={`${styles.letterSpacing} text-dark font-weight-600 font-size-24`}
            >
              {value ? value : "-"}
              <span className="text-light font-size-14 font-weight-400">
                {value2 ? `(${value2})` : ""}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
      {siteEnergySource && (
        <Row>
          <Col>{siteEnergySource}</Col>
        </Row>
      )}
      <div className={`${styles.siteEnergySource}`}>
        {isMoreInfo && <>{otherInfo}</>}
      </div>
      <Row
        className={`justify-content-center ${hideArrowIcon ? `my-2` : `my-1`}`}
      >
        <Col className="col-auto">
          <MaterialIcon
            icon={isMoreInfo ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            color="#AEBBD0"
            size={18}
            className={`cursor-pointer ${hideArrowIcon ? `d-none` : `d-block`}`}
            onClick={() => setIsMoreInfo((ps) => !ps)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EnergyFlowNode;
